<template>
  <div>
    <div class="listitem" v-for="(item,index) in liverlistDate" @click="fntoliver(item,item.live_status)">
       <div class="tags" v-if="item.live_status == 2">直播中</div>
       <div class="tags tagsblue" v-if="item.live_status == 1">待开播</div>
       <div class="tags tagsblue" v-if="item.live_status == 3">已结束</div>
       <img class="productimg" :src="item.cover"></img>
       <div class="itemright">
            <div class="title">{{item.name}}</div>
            <div class="bottom">
                <div class="dec">
                    <span ><img src="@/assets/images/timeicon.png"></img>{{item.start_time}}</span>
                    <!-- <span v-if="item.live_status == 1 && (item.dd || item.hh || item.mm || item.ss) ">距开播还有
                        <span v-if="item.dd">{{item.dd}}天</span>
                        {{item.hh ||  '00'}}:{{item.mm  || '00'}}:{{item.ss}}
                    </span> -->

                </div>
                <div style="display: flex;align-items: center;">
                  <div class="jiami" v-if="item.encryption_status == 2">加密</div>
                  <div class="checkbtn" v-if="item.live_status == 2 || item.live_status == 3">立即观看</div>
                  <!-- <div class="checkbtn checkbtnhui"  v-if="item.live_status == 1 && item.attention ==1" >已订阅</div>
                  <div class="checkbtn" v-if="item.live_status == 1 && item.attention == 2" @click.stop="booklive(item.attention,item.id)">订阅提醒</div> -->
                </div>
            </div>
       </div>
    </div>
  </div>
</template>
<script>
import {difftime,nowDate} from '../utils/duringdate'
// import {liverremind} from '@/api/live'
import {
    Toast,
    Dialog
  } from 'vant'
export default {
    props:{
      liverlistDate:{
        type:Array,
      }
    },
    data(){
        return{
            difftimeobj:null,
            groups:this.liverlistDate
        }
    },
    mounted(){

    },
    methods:{
        fntoliver(item,status){
          // if(status == 1){
          //   return false
          // }
          this.$emit('fntoliver',item.id)

        },
        // booklive(status,id){
        //     liverremind({
        //       live_id: id,
        //       oid:store.getters.userInfo.uid,
        //       user_id: '',
        //       attention:status==2? "1":"2"
        //     })
        //     .then((res) => {
        //       if(res.code == 200){
        //         Toast('订阅成功')
        //         setTimeout(()=>{
        //           this.$emit('fnsub',res.data.live_id)
        //         },500)
        //       }else{
        //         Toast(res.message)
        //       }
        //     })

        // },

    },
}
</script>
<style lang="less" scoped>
    .listitem{
        border-bottom: 1px solid #ccc;
        display: flex;
        padding: 15px 0;
        position: relative;
        .tags{
            height:20px;
            line-height: 20px;
            font-size: 12px;
            background:#fb481e;
            color: #fff;
            position: absolute;
            top:15px;
            left: 0;
            padding: 0 10px;
            z-index: 1;
        }
        .tagsblue{
            background:#0027d1;
        }
        .productimg{
            width: 100px;
            height:75px;
            object-fit: cover;
            margin-right:10px;
            flex-shrink:0;

        }
        .itemright{
            width: 100%;
        }
        .title{
            font-weight: 600;
            font-size: 16px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            width: 240px;
            text-align: initial;
        }
        .dec{
            font-size: 8px;
            display: flex;
            flex-direction: column;
            width: 170px;
            margin-top: 15px;
            text-align: initial;
            span{
                color: #999;
                img{
                    width:12px;
                    height: 12px;
                    vertical-align: middle;
                    margin-right: 10px;
                    position: relative;
                    top: -2px;

                }
            }
            .shopname{
              margin-bottom: 6px;
            }

        }
        .bottom{
            display: flex;
            justify-content: space-between;
        }
        .jiami{
          color: red;
          font-size:22px;
          margin-right: 6px;
          margin-top: 20px;
        }

        .checkbtn{
            width: 60px;
            height:27px;
            background: #ffd800;
            font-size: 12px;
            line-height: 27px;
            border-radius: 3px;
            text-align: center;
            margin-top: 20px;
        }
        .checkbtnhui{
            background: #eee;
            color: #999;
        }
    }
    .listitem:last-child{
        border-bottom: 0;
    }
</style>
